import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-home-final-cta',
  templateUrl: './home-final-cta.component.html',
  styleUrls: ['./home-final-cta.component.scss']
})
export class HomeFinalCtaComponent {
  @Output() smoothScrollEvent = new EventEmitter<string>();

  smoothScroll(sectionId: string, event?: Event): void {
    if (event) {
      event.preventDefault();
    }
    this.smoothScrollEvent.emit(sectionId);
  }
}